import React, {useCallback, useEffect, useRef, useState} from "react";
import { projData } from "../../globals/data";
import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion, usePresence } from "framer-motion";
import { useInView } from "react-intersection-observer";
import debounce from 'lodash.debounce';
import LocomotiveScroll from 'locomotive-scroll';
import './homepagemob.css';
import ProgressiveBackgroundImg from "../../components/ProgressiveBackgroundImg/ProgressiveBackgroundImg";
import { getGutterWidth, smoothScrollTo } from "../../globals/helpers";
import { extVideoInStart } from "../loader/variables";

const HomepageMob = ({isFirstLoad}) => {
    const navigate = useNavigate();
    const [isPresent, safeToRemove] = usePresence();
    const mThumbTransition = "transform 1s cubic-bezier(0.16, 1, 0.3, 1)";
    const [heroInView, setHeroInView] = useState(true);
    const [activeIndex, setActiveIndex] = useState(null);
    const [activeMetaIndex, setActiveMetaIndex] = useState(0);
    const [selected, setSelected] = useState(-1);
    const [activeGoTo, setActiveGoTo] = useState(null);
    const [scrollDirection, setScrollDirection] = useState(null);
    const [heroHeight, setHeroHeight] = useState(null);
    const [scroller, setScroller] = useState(null);
    const tileImgRefs = useRef([]);
    const mobHeroWrapperRef = useRef(null);
    const [useFirstLoad, setUseFirstLoad] = useState(null);

    const scrollRef = useRef(null);
    let imgAspectRatios = 1.9;
    const heroSpanRef = useRef(null);
    const hollowRefs = useRef([]);

    const itemWrapperRef = useRef(null);
    const itemRefs = useRef([]);
    const thumbRefs = useRef([]);
    const thumbMoverRefs = useRef([]);
    const leftMetaRefs = useRef([]);
    const rightMetaRefs = useRef([]);

    const footerSocialRefs = useRef([]);
    const footerRef = useRef(null);


    const { ref: secondarySecRef, inView: footerInView } = useInView({
        triggerOnce: false, // Trigger only once when entering the viewport
        threshold: 0, // Trigger when 50% of the element is in view (adjust this based on your needs)
    });

    const scrollTop = () => {
        try{
            smoothScrollTo(
                scrollRef.current,
                0,
                0,
                1750,
                [0.85, 0, 0.15, 1]
            );
        } catch{}
    }

    const mainHeroVariants = {
        initial: (i) => ({
            transform: `translate3d(0%, -100%, 0)`,
            opacity: 0
        }), animate: (i) => ({
            transform: `translate3d(0%, 0, 0)`,
            opacity: 1,
            transition: {
                duration: i[1] ? 1.75 :1.25,
                ease: [0.16, 1, 0.3, 1],
                delay: i[1] ? extVideoInStart + 0.2 + (0.05 * i[0]) : 0.05 * i[0]
            }
        }), exit: (i) => ({
            transform: `translate3d(0%, -100%, 0)`,
            opacity: 0,
            transition: {
                duration: 1,
                ease: [0.16, 1, 0.3, 1],
                delay: 0.05 * i[0]
            }
        })
    }

    const subHeroVariants = {
        initial: (i) => ({
            transform: `translate3d(0%, 100%, 0)`,
            opacity: 0
        }), animate: (i) => ({
            transform: `translate3d(0%, 0, 0)`,
            opacity: 1,
            transition: {
                duration: i[1] ? 1.75 :1.25,
                ease: [0.16, 1, 0.3, 1],
                delay: i[1] ? extVideoInStart + 0.2 + (0.05 * i[0]) + 0.15 : 0.05 * i[0] + 0.15
            }
        }), exit: (i) => ({
            transform: `translate3d(0%, -100%, 0)`,
            opacity: 0,
            transition: {
                duration: 1,
                ease: [0.16, 1, 0.3, 1],
                delay: 0.05 * i[0]
            }
        })
    }


    const handleItemClick = (e, selectedIdx) => {
        setActiveIndex(selectedIdx);

        try{
            scrollRef.current.style.overflow = "hidden"
        }catch{}
        if(thumbRefs.current){
            let targetElement = thumbRefs.current[selectedIdx];
            let minRange = Math.max(0, selectedIdx - 2);
            let maxRange = Math.min(selectedIdx + 2, itemRefs.current.length-1);
            let delayDelta = 0.05;
            let delayBy;


            let selectedRef = thumbRefs.current[selectedIdx];
            let boundingInfo = selectedRef.getBoundingClientRect();
            let curWidth = boundingInfo.width;
            let curHeight = boundingInfo.height;
            let yPos = boundingInfo.y;
            
            let selectedTop = yPos;
            let selectedBottom = yPos + curHeight;

            let screenBounds = [0, window. innerHeight]
            
            let numberAboveWithinView = 0;
            let numberBelowWithinView = 0;
            for(let i=0; i<projData.length; i++){
                let tmpAboveBottom = selectedTop - 20 - (i * curHeight);
                if(tmpAboveBottom > screenBounds[0]){
                    numberAboveWithinView += 1
                }

                let tmpBelowTop = selectedBottom + 20 + (i*curHeight);
                if(tmpBelowTop < screenBounds[1]){
                    numberBelowWithinView += 1;
                }
            }

            let animOutBonds = [
                Math.max(0, selectedIdx - numberAboveWithinView),
                Math.min(projData.length - 1, selectedIdx + numberBelowWithinView)
            ]

            let delayStep = 0.05;
            for(let i = animOutBonds[0]; i<=animOutBonds[1]; i++){
                let adjustedDelayIdx = i - animOutBonds[0];
                if( i!== selectedIdx){

                    thumbMoverRefs.current[i].style.transform = 'translate3d(0, 102%, 0)';
                    thumbMoverRefs.current[i].style.opacity = 0;
                    thumbMoverRefs.current[i].style.transitionDelay = delayStep * adjustedDelayIdx + "s"


                    
                } else{
                    let targetYPos = 60;
                    let yDelta = targetYPos - yPos;
                    let targetWidth = window.innerWidth - (2* getGutterWidth(window.innerWidth).main);
                    let xScaler = targetWidth / curWidth;
                    let targetAspectRatio = 9/16;
                    let yScaler;

                    if(window.innerWidth <= 775){
                        targetAspectRatio = projData[selectedIdx].aspectRatio;
                    }

                    let targetHeight = (1/targetAspectRatio) * targetWidth;
                    yScaler = targetHeight/curHeight;
                
                    let targetThumb = tileImgRefs.current[selectedIdx]

                    delayBy = 0.5 + (delayStep * adjustedDelayIdx);
                    selectedRef.style.transitionDelay = delayBy + "s";
                    targetThumb.style.transition = mThumbTransition;
                    targetThumb.style.transitionDelay = delayBy + "s";


                    selectedRef.style.transform = `translate3d(0, ${yDelta}px, 0) scale3d(${xScaler},${yScaler},1)`;
                    targetThumb.style.transform = "scale3d(1, "+1/yScaler+", 1)";

                }
                leftMetaRefs.current[i].style.transform = 'translate3d(0, 102%, 0)';
                leftMetaRefs.current[i].style.transitionDelay = delayStep * adjustedDelayIdx + "s"

                rightMetaRefs.current[i].style.transform = 'translate3d(0, 102%, 0)';
                rightMetaRefs.current[i].style.transitionDelay = delayStep * adjustedDelayIdx + "s"
            }

            

            // let targetImg = selectedRef.getElementsByClassName("full-thumb")[0];
            // targetImg.style.transition = `transform 1s ${delayBy}s cubic-bezier(0.16, 1, 0.3, 1)`;
            // targetImg.style.transformOrigin = "center";
            // targetImg.style.transform = `scale3d(1, ${xScaler/yScaler}, 1)`;
            // let targLeftMeta = leftMetaRefs.current[i];
            // let targRightMeta = rightMetaRefs.current[i];

            // targLeftMeta.style.transitionDelay = relativeIVal * delayDelta + "s";
            // targRightMeta.style.transitionDelay = relativeIVal * delayDelta + "s";
            // targLeftMeta.style.transform = "translate3d(0, 100%, 0)";
            // targRightMeta.style.transform = "translate3d(0, 100%, 0)";
            setSelected(selectedIdx)
            
            // let navDelay = 1000 + (delayBy * 1000)
            let navUrl = '/projects/'+projData[selectedIdx].title;
            navigate(navUrl, {state:{isFromHome:true}});
            
        }
    }

    useEffect(() => {
        if(!isPresent){
            try{
                scrollRef.current.style.overflow = "hidden"
            }catch{}
            itemWrapperRef.current.style.pointerEvents="none";
            scrollRef.current.style.pointerEvents="none";
            if(selected !== -1){
                setTimeout(() => {
                    safeToRemove();
                }, 1500)

                if(footerInView){
                    footerRef.current.style.transition = "transform 1s cubic-bezier(0.87, 0, 0.13, 1), opacity 1s cubic-bezier(0.87, 0, 0.13, 1)";
                    footerRef.current.style.transitionDelay = 0 + "s"
                    footerRef.current.style.transform = "translate3d(0, 100%, 0)";
                    footerRef.current.style.opacity = "0";
                    for(let i = 0; i < footerSocialRefs.current.length; i++){
                        let tmpRef = footerSocialRefs.current[i];
                        tmpRef.style.transition = "transform 1s cubic-bezier(0.87, 0, 0.13, 1), opacity 1s cubic-bezier(0.87, 0, 0.13, 1)";
                        tmpRef.style.transitionDelay = 0.1 * i + "s"
                        tmpRef.style.transform = "translate3d(0, 100%, 0)";
                        tmpRef.style.opacity = "0";
                    }
                }
            } else{
                let heroBounding = mobHeroWrapperRef.current.getBoundingClientRect();
                let heroHeight = heroBounding.height;
                let heroMargin = 60;
                let adjustedHeroOffset = heroHeight + heroMargin + 60;
                let exampleRef = itemRefs.current[0];
                let boundingInfo = exampleRef.getBoundingClientRect();
                let tileHeight = boundingInfo.height + 20;

                let scrollVal = scrollRef.current.scrollTop
                let adjustedScrollVal = scrollVal - adjustedHeroOffset;

                let bottomVisbilePos = adjustedScrollVal + window.innerHeight;

                let topIdx = Math.max(0, Math.floor(adjustedScrollVal/tileHeight))
                let bottomIdx = Math.min(projData.length -1, Math.floor(bottomVisbilePos/tileHeight))
            
                let delayStep = 0.1;
                for(let i = topIdx; i<= bottomIdx; i++){
                    let adjustedIdx = i-topIdx;
                    thumbMoverRefs.current[i].style.transition = "transform 1s cubic-bezier(0.87, 0, 0.13, 1), opacity 1s cubic-bezier(0.87, 0, 0.13, 1)"
                    thumbMoverRefs.current[i].style.transitionDelay = delayStep * adjustedIdx + "s"
                    thumbMoverRefs.current[i].style.opacity = 0;
                    thumbMoverRefs.current[i].style.transform = 'translate3d(0, 102%, 0)';

                    leftMetaRefs.current[i].style.transition = "transform 1s cubic-bezier(0.87, 0, 0.13, 1), opacity 1s cubic-bezier(0.87, 0, 0.13, 1)"
                    leftMetaRefs.current[i].style.transitionDelay = 0.075 + delayStep * adjustedIdx + "s"
                    thumbMoverRefs.current[i].style.opacity = 0;
                    leftMetaRefs.current[i].style.transform = 'translate3d(0, 102%, 0)';
    
                    rightMetaRefs.current[i].style.transition = "transform 1s cubic-bezier(0.87, 0, 0.13, 1), opacity 1s cubic-bezier(0.87, 0, 0.13, 1)"
                    rightMetaRefs.current[i].style.transitionDelay = 0.125 + delayStep * adjustedIdx + "s"
                    rightMetaRefs.current[i].style.transform = 'translate3d(0, 102%, 0)';
                    thumbMoverRefs.current[i].style.opacity = 0;
                }

                if(footerInView){
                    let footerOffset = bottomIdx - topIdx;
                    footerRef.current.style.transition = "transform 1s cubic-bezier(0.87, 0, 0.13, 1), opacity 1s cubic-bezier(0.87, 0, 0.13, 1)";
                    footerRef.current.style.transitionDelay = 0.125 + (delayStep * footerOffset) + "s"
                    footerRef.current.style.transform = "translate3d(0, 100%, 0)";
                    footerRef.current.style.opacity = "0";
                    for(let i = 0; i < footerSocialRefs.current.length; i++){
                        let tmpRef = footerSocialRefs.current[i];
                        tmpRef.style.transition = "transform 1s cubic-bezier(0.87, 0, 0.13, 1), opacity 1s cubic-bezier(0.87, 0, 0.13, 1)";
                        tmpRef.style.transitionDelay = 0.125 + (delayStep * (footerOffset + (0.25 * i))) + "s"
                        tmpRef.style.transform = "translate3d(0, 100%, 0)";
                        tmpRef.style.opacity = "0";
                    }
                }

                setTimeout(() => {
                    safeToRemove();
                }, 1000)
            }
            
        } 
    }, [isPresent, selected])

    const handleScrolling = (e) => {
        let currentScrollTop = e.target.scrollTop;
        let parallaxTransform;
        if(heroSpanRef.current){
            let parallaxMulti = 5;
            let tmpHeight = heroSpanRef.current.offsetHeight + 60;
            let scrollToLeave = tmpHeight - ((tmpHeight+60)/parallaxMulti) + 60;
            let scrollProg = currentScrollTop / scrollToLeave;


            if(scrollProg <= 1){
                parallaxTransform = currentScrollTop/parallaxMulti;
                heroSpanRef.current.style.transform = `translate3d(0%, -${parallaxTransform}px, 0)`
                heroSpanRef.current.style.opacity = `${1 - scrollProg}`
                let deltaEffect = 5;
                for(let i=0; i<hollowRefs.current.length; i++){
                    let tmpHollow = hollowRefs.current[i];
                    let maxTransformBy = (i + 1) * deltaEffect
                    let transformVal = parallaxTransform + (maxTransformBy * scrollProg)
                    tmpHollow.style.transform = `translate3d(-50%, ${transformVal}px, 0)`
                }
                setHeroInView(true);
            } else{
                setHeroInView(false)
            }
        }
    }

    useEffect(() => {
        if(scrollRef.current){
            let a = scrollRef.current.addEventListener("scroll", handleScrolling);
        }


    }, [scrollRef.current])

    useEffect(() => {
        if(isFirstLoad){
            setUseFirstLoad(true)
        }else setUseFirstLoad(false)
    }, [])

    useEffect(()=> {
        if(heroSpanRef.current){
            let tmpHeight = heroSpanRef.current.offsetHeight + 60 + 20 
            setHeroHeight(tmpHeight);
        }
    }, [heroSpanRef])

    return(
        <>
            { projData &&
            <motion.div 
                key={"homepage_wrapper"}
                className={`homepage_wrapper`}
                initial="initial"
                animate="animate"
                exit="exit"
                style={{
                    overflow: "scroll"
                }}
                ref={scrollRef}
            >
                <div
                    className="home_content_wrapper"
                >   
                    <div 
                        key={"m_scroll_wrapper"}
                        className="scroll_wrapper" 
                        
                    >
                        <div 
                            className="m_items__wrapper"
                            ref={itemWrapperRef}
                        >
                            <div 
                                className="mob_hero__wrapper"
                                ref={mobHeroWrapperRef}
                                >
                                <div 
                                    className="m-main-hero__wrapper" 
                                    style={{overflow: "hidden"}}
                                    ref={heroSpanRef}
                                >
                                    <motion.span
                                        className="hero_img__wrapper"
                                        style={{
                                            zIndex: 0
                                        }}
                                        initial="initial"
                                        animate={selected < 0 ? "animate" : "exit"}
                                        exit="exit"
                                        variants={mainHeroVariants}
                                        custom={[1, isFirstLoad]}
                                    >
                                        <img 
                                            className="home-upper-logo"
                                            src="../media/branding/logo-upper.png"
                                            style={{
                                                maxWidth: "90%"
                                            }}    
                                        />
                                    </motion.span>
                                    <div className="lower-logo-wrapper">
                                        <motion.img
                                            className="home-lower-logo"
                                            src="../media/branding/logo-lower.png"
                                            initial="initial"
                                            animate="animate"
                                            exit="exit"
                                            variants={subHeroVariants}
                                            custom={[0, isFirstLoad, 0.15]}
                                        />
                                    </div>
                                </div>
                            </div>
                            { useFirstLoad !== null && heroHeight && projData.map((item, idx) => (
                                <motion.div 
                                    className={`m_item__wrapper ${idx <= 4 ? 'm_item_anim_in' : 'm_item_static'}`}
                                    ref={el => itemRefs.current[idx] = el}
                                    onClick={(e) => handleItemClick(e, idx)}
                                >
                                    <div className="m_it_thumb__wrapper"
                                        style={{
                                            width: "100%",
                                            aspectRatio:imgAspectRatios,
                                            position: "relative",
                                            transition: mThumbTransition,
                                            willChange: "transform",
                                            transformOrigin: "top",
                                            overflow: "hidden"
                                        }}  
                                        ref={el => thumbRefs.current[idx] = el}
                                    >
                                        <div 
                                            className="m_thumb_slider"
                                            ref={el => thumbMoverRefs.current[idx] = el}    
                                        >
                                            <div 
                                                className={`ts-thumb__wrapper`}
                                                style={{
                                                    top: 0,
                                                    left: 0,
                                                    overflow: "hidden",
                                                    animationDelay: idx <= 4 ? useFirstLoad ? extVideoInStart + 0.2 +( 0.1 * idx) +"s" : 0.25 + 0.1 * idx + "s" : null,
                                                    animationDuration: idx <= 4 && useFirstLoad ? "1.75s" : null
                                                }}
                                            >
                                                <ProgressiveBackgroundImg
                                                    key={"m-progressive-"+idx}
                                                    placeholderSrc={projData[idx].thumbnails.placeholder}
                                                    src={projData[idx].thumbnails.mobile}
                                                    idx={idx}
                                                    isFirefox={false}
                                                    thumbRefs={tileImgRefs}
                                                />
                                                {/* <img src 
                                                    style={{
                                                        backgroundImage: 'url('.concat(projData[idx].thumbnails.laptop.toLowerCase(),')')
                                                    }}
                                                /> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="m_it_meta__wrapper" >
                                        <span 
                                            style={{display: "inline-block", fontWeight: 800}} 
                                            ref={el => leftMetaRefs.current[idx] = el}
                                        >
                                            <span 
                                                className="mob_item_title"
                                                style={{
                                                    animationDelay: idx <= 4 ? useFirstLoad ? extVideoInStart + 0.2 + (0.15 * idx) +"s" :(idx * 0.15) + 0.5 + "s" : 0,
                                                    animationDuration: idx <= 4 && useFirstLoad ? "1.75s" : null
                                                }}
                                            >{item.title}</span>
                                        </span>
                                        <span ref={el => rightMetaRefs.current[idx] = el}>
                                            <span
                                                className="mob_item_artist"
                                                style={{
                                                    animationDelay: idx <= 4 ? useFirstLoad ? extVideoInStart + 0.2 + (0.15 * idx) +"s" :(idx * 0.15) + 0.5 + "s" : 0,
                                                    animationDuration: idx <= 4 && useFirstLoad ? "1.75s" : null
                                                }}
                                            >
                                                {item.artist}
                                            </span>
                                        </span>
                                    </div>
                                </motion.div>
                            ))}
                            { heroHeight && projData &&
                                <div className="m_home_footer" ref={secondarySecRef}>
                                    <div 
                                        className="top-scroller"
                                        
                                    ><span ref={footerRef} onClick={scrollTop}>BACK TO THE TOP</span></div>
                                    <div className="m-footer-socials">
                                        <span
                                            ref={el=> footerSocialRefs.current[0] = el}
                                        ><a href="https://www.instagram.com/donprod/?hl=en" target="_blank">INSTA</a></span>
                                        <span
                                            ref={el=> footerSocialRefs.current[1] = el}
                                        ><a href="https://www.tiktok.com/@donprod?lang=en" target="_blank">TIKTOK</a></span>
                                        <span
                                            ref={el=> footerSocialRefs.current[2] = el}
                                        > <a href="https://vimeo.com/donprod" target="_blank">VIMEO</a></span>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </motion.div>
            }
        </>
    )
}
export default HomepageMob;
